<template>
  <!-- Documentación https://github.com/lewis-kori/vue-google-translate -->
  <b-card class="border-none border-0 p-2" no-body>
    <b-card-text class="p-0 m-0 pl-2 pt-2">
      <h4 class="p-0 m-0"><strong>Traducir SOLUQUIM</strong></h4>
      <div class="d-flex align-items-center mt-2">
        <b-badge variant="primary" class="p-2 m-0 mr-2">3</b-badge>idiomas disponibles para traducir el sistema.
      </div>
    </b-card-text>
    <Translator :countries="countries" @on-country-click="hideModal" />

    <p class="text-muted m-0 p-0">
      SOLUQUIM traducirá todos los textos disponibles para tí, debes tener en cuenta que este proceso solo es visual y no afecta la información.
    </p>
  </b-card>
</template>

<script>
import { Translator } from "vue-google-translate";
export default {

name: "TranslateModal",

components: {
  Translator,
},

data() {
  return {
    countries: []
  };
},

mounted() {
  this.fetchCountries();
},

methods: {
  
  fetchCountries() {
    this.countries = [
      {
        code: "es|en",
        title: "Inglés",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/gb.svg",
        altText: "English",
      },
      {
        code: "es|es",
        title: "Español",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/es.svg",
        altText: "Spanish",
      },
      {
        code: "es|pt",
        title: "Portuguese",
        flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/pt.svg",
        altText: "Portuguese",
      }
    ]; 
  },

  hideModal() {
    this.$bvModal.hide("translate-modal");
  }

},
};
</script>
<style scoped>

</style>
